<template lang="pug">
  div(
  v-if="mappingCurrentLegend && mappingCurrentLegend.title && !mappingCurrentLegend.hideLegend"
  ).map-mapping-legend
    div.map-mapping-legend__title {{$translate(mappingCurrentLegend.title)}}
    div(
      v-for="item in legendItems"
    ).map-mapping-legend__item
        div(
          :style="{'background-color': (item.color), opacity:  (item.fillOpacity || item.opacity || 1)}"
        ).map-mapping-legend__color
        div.map-mapping-legend__head {{$translate(item.title)}}
</template>

<script>
export default {
  name: 'map-mapping-legend',
  props: {
    mappingCurrentLegend: Object,
    legendItems: Array,
  },
}
</script>
